import React,{ useEffect } from "react";
import InnerPopup from "./InnerPopup";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { withTranslation } from "react-i18next";
import UseBodyScrollLock from "./UseBodyScrollLock";
import ReactDOM from "react-dom";
const ConfirmBetDeskonPopup = (props) => {
  const { onClose, message, mainContent } = props;
  const showModal = true;
  const callProcessSubmit = () => {
    props.submitProcessOk();
  };
  UseBodyScrollLock(showModal);
  useEffect(() => {
    const wrapperElement = document.querySelector(".wrapper");

    if (wrapperElement) {
      // Add the 'modal-open' class when the modal is open
      wrapperElement.classList.add("modal-open");
    }

    // Cleanup function to remove the class when the component is unmounted
    return () => {
      if (wrapperElement) {
        wrapperElement.classList.remove("modal-open");
      }
    };
  }, []);

  const wrapperElement = document.querySelector(".homepage");
  

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        event.preventDefault(); 
        callProcessSubmit();
      }
    };

    document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [callProcessSubmit]);

  return ReactDOM.createPortal(
    <>
      {showModal && (
        <div className="confirmation_modal">
          <InnerPopup onCloseModal={onClose}>
            <div className="betdiskon_poupcontent">
              <div className="confirm_img_conatiner">
                <IoIosInformationCircleOutline />
              </div>
              <h3>{ mainContent ? mainContent : (props.t("process_bet"))} ?</h3>
              <p>{message ? message : ""}</p>
              <div className="confirm_poupcontent_btns">
                <button className="btn" onClick={onClose}>
                  {props.t("no")}
                </button>
                <button className="btn" onClick={callProcessSubmit}>
                  {props.t("yes")}
                </button>
              </div>
            </div>
          </InnerPopup>
        </div>
      )}
    </>,
    wrapperElement
  );
};

export default withTranslation()(ConfirmBetDeskonPopup);
